<template>
  <div class="index flex">
    <div class="content-box">
      <div class="user-info">
        <!-- <el-avatar class="head-icon" :src="userInfo.avatar"></el-avatar> -->
        <el-upload
          class="userInfo.avatar?'avatar-uploader':avatarborder avatar-uploader"
          :action="baseUrl + '/business/user/updateAvatar'"
          :show-file-list="false"
          :headers="{
            Authorization: gettoken,
          }"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          name="avatarFile"
        >
          <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div class="user-name">
          {{
            userInfo.nickName ? userInfo.nickName : "用户" + userInfo.userName
          }}
        </div>
        <div class="justify-center">
          <div class="read-list">
            <img style="width: 27px; height: 23px" src="./images/yuedu.png" />
            {{ bookData.total || 0 }}
          </div>
          <!-- <div class="read-list">
            <img style="width: 25px; height: 27px" src="./images/sign.png" />
            {{ noteData.total || 0 }}
          </div> -->
          <div class="read-list">
            <!-- <i class="el-icon-star-off"></i> -->
            <img
              style="width: 28px; height: 27px"
              src="./images/collection.png"
            />
            {{ collectData.total || 0 }}
          </div>
          <!-- <div class="read-list">
            <img style="height: 28px" src="./images/note.png" />
            {{ tableData.total || 0 }}
          </div> -->
        </div>
        <div class="user center">
          <div class="user-box">
            <div class="box-title center">
              <img src="./images/user-icon.png" />
              个人信息
              <img
                @click="isInput = !isInput"
                style="cursor: pointer"
                src="./images/edite-icon.png"
              />
            </div>
            <!-- <div class="between">
              <label>暱稱：</label>
              <span>{{ userInfo.nickName }}</span>
            </div>
            <div class="between">
              <label>機構：</label>
              <el-tag type="success" v-if="userInfo.organization">{{
                userInfo.organization
              }}</el-tag>
            </div>
            <div class="between">
              <label>郵箱：</label>
              <span>{{ userInfo.mail }}</span>
            </div>
            <div class="between">
              <label>學歷：</label>
              <span>
                {{ userInfo.qualification }}
              </span>
            </div>
            <div class="between">
              <label>專業：</label>
              <span>
                {{ userInfo.major }}
              </span>
            </div> -->
            <el-form ref="form" :model="userInfo" label-width="80px">
              <el-form-item label="暱稱：">
                <span v-show="!isInput" class="fontstyle">{{
                  userInfo.nickName
                }}</span>
                <el-input
                  v-show="isInput"
                  v-model="userInfo.nickName"
                ></el-input>
              </el-form-item>
              <el-form-item label="手機：">
                <span class="fontstyle">{{ userInfo.mobile }}</span>
              </el-form-item>
              <el-form-item label="機構：">
                <span class="fontstyle" v-show="!isInput">
                  {{ userInfo.organization }}</span
                >
                <el-input
                  v-show="isInput"
                  v-model="userInfo.organization"
                ></el-input>
              </el-form-item>
              <el-form-item label="郵箱：">
                <span class="fontstyle" v-show="!isInput">
                  {{ userInfo.mail }}</span
                >
                <el-input v-show="isInput" v-model="userInfo.mail"></el-input>
              </el-form-item>
              <el-form-item label="學歷：">
                <span class="fontstyle" v-show="!isInput">{{
                  userInfo.qualification
                }}</span>
                <el-input
                  v-show="isInput"
                  v-model="userInfo.qualification"
                ></el-input>
              </el-form-item>
              <el-form-item label="專業：">
                <span class="fontstyle" v-show="!isInput">{{
                  userInfo.major
                }}</span>
                <el-input v-show="isInput" v-model="userInfo.major"></el-input>
              </el-form-item>

              <!-- <el-form-item label="賬户類型：">
                <span class="fontstyle" v-show="!isInput">{{
                  userInfo.rankId
                }}</span>
              </el-form-item>
              <el-form-item label="到期時間：">
                <span class="fontstyle" v-show="!isInput">{{
                  userInfo.vipValidityDate
                }}</span>
              </el-form-item> -->
            </el-form>

            <!-- <div class="between">
              <label>賬户類型：</label>
              <span>
                {{ userInfo.rankId }}
              </span>
            </div>

            <div class="between">
              <label>到期時間：</label>
              <span :class="ismature ? 'redicon' : ''">{{
                userInfo.vipValidityDate
              }}</span>
            </div> -->

            <!-- 
            <div class="tag-block center">綁定卡號</div> -->
            <!-- <el-button type="primary" size="small" @click="editUserInfo"
              >确认</el-button
            > -->
            <div
              class="tag-block center"
              v-show="isInput"
              @click="editUserInfo"
            >
              確認
            </div>
            <!-- <div
              class="tag-block center"
              @click="$router.push({ path: '/products' })"
            >
              充值中心
            </div> -->
            <div class="tag-block center" @click="getout">退出登録</div>
          </div>
        </div>
      </div>
      <div class="content">
        <el-tabs v-model="activeName">
          <el-tab-pane label="我的閲讀" name="read"></el-tab-pane>
          <el-tab-pane label="我的收藏" name="collect"></el-tab-pane>
          <!-- <el-tab-pane label="我的訂單" name="order"></el-tab-pane> -->
        </el-tabs>
        <div v-if="activeName == 'collect'">
          <el-card
            class="box-card"
            v-for="item in collectData.rows"
            :key="item.bookId"
          >
            <img
              class="img imgbccolor"
              :src="baseUrl + item.busBook.coverImageUrl"
            />
            <div class="layer center">
              <div class="sm-title flex-col justify-center">
                <router-link
                  class="align-center center"
                  target="_blank"
                  :to="
                    '/view?id=' +
                    item.bookId +
                    '&bookName=' +
                    item.busBook.bookName +
                    '&page=1'
                  "
                >
                  <img src="./images/eye.png" />
                  查看文獻
                </router-link>

                <div
                  class="align-center center"
                  @click="deleteFavor(item.favorId)"
                >
                  <img src="./images/delete-a.png" />
                  删除
                </div>
              </div>
            </div>
          </el-card>
          <div class="center">
            <el-pagination
              background
              :current-page="collectData.pageNum"
              layout="prev, pager, next"
              @current-change="getPageNum"
              :page-size="collectData.pageSize"
              :total="collectData.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-if="activeName == 'read'">
          <el-card
            class="box-card"
            v-for="item in bookData.rows"
            :key="item.bookId"
          >
            <img
              class="img imgbccolor"
              style="width: 100%; height: auto"
              :src="baseUrl + item.busBook.coverImageUrl"
            />
            <div class="layer center">
              <div class="sm-title flex-col justify-center">
                <router-link
                  target="_blank"
                  class="align-center center"
                  :to="'/view' + getBookReadParam(item)"
                >
                  <img src="./images/eye.png" />
                  查看
                </router-link>

                <div
                  class="align-center center"
                  @click="deleteRead(item.bookId)"
                >
                  <img src="./images/delete-a.png" />
                  删除
                </div>
              </div>
            </div>
          </el-card>
          <div class="center">
            <el-pagination
              background
              :current-page="bookData.pageNum"
              layout="prev, pager, next"
              @current-change="getNookNum"
              :page-size="bookData.pageSize"
              :total="bookData.total"
            >
            </el-pagination>
          </div>
        </div>
        <!-- <div v-if="activeName == 'order'" class="flex-col">
          <el-card class="cover">
            
            <el-table
              ref="multipleTable"
              :data="orderList"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              :default-sort="{ prop: 'createTime', order: 'descending' }"
            >
              <el-table-column type="selection"> </el-table-column>
              <el-table-column label="訂單類型" prop="orderName">
               
              </el-table-column>
              <el-table-column
                prop="orderNum"
                label="訂單編號"
                width="160"
                sortable
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="下單時間"
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              
              <el-table-column
                prop="realTotal"
                label="訂單金額"
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              
            </el-table>
            <el-pagination
              layout="prev, pager, next"
              :total="orderListTotal"
              @current-change="orderListPageChange"
            >
            </el-pagination>
          </el-card>
        </div> -->
      </div>

      <!-- <el-dialog
        width="70%"
        height="70vh"
        trigger="click"
        :visible.sync="dialogVisibletwo"
      >
        <el-table
          :data="noteList.data"
          style="width: 100%; height: 70vh; overflow: auto"
          :default-sort="{
            prop: 'createTime',
            order: 'descending',
          }"
          @sort-change="paixuNode"
        >
          <el-table-column
            width="100"
            property="juanNum"
            label="卷"
            sortable
          ></el-table-column>
          <el-table-column
            property="juanName"
            sortable="custom"
            label="卷名"
          ></el-table-column>
          <el-table-column
            property="noteTarget"
            label="選擇文字"
          ></el-table-column>
          <el-table-column
            property="noteContent"
            label="筆記"
          ></el-table-column>
          <el-table-column
            property="createTime"
            label="創建時間"
            sortable
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                            size="mini"
                            @click="handleEdit(scope.$index, scope.row)"
                            >编辑</el-button
                          >

                          <div
                            class="align-center center"
                            @click="handleDelete(scope.row.noteId)"
                          >
                            <img src="./images/delete-a.png" />
                            删除
                          </div>

              <div class="layer">
                <div class="sm-title flex-col justify-start">
                  <router-link
                    target="_blank"
                    class="align-center"
                    :to="`/viewer?bookId=${xzlist.bookId}&bookName=${xzlist.bookName}&noteId=${scope.row.noteId}&juanNum=${scope.row.juanNum}&xmlIc=${scope.row.xmlId}&juanNum=${scope.row.juanNum}&source=uc`"
                    style="text-decoration-line: none; color: #3366cc"
                  >
                    <img src="./images/edite-icon.png" class="dialogimg" />
                    编辑
                  </router-link>
                  <div
                    class="align-center pointe"
                    style="margin-top: 20px"
                    @click="handleDelete(scope.row.noteId)"
                  >
                    <img src="./images/delete-a.png" class="dialogimg" />
                    删除
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="noteList.pageNum"
          layout="prev, pager, next,total"
          size="small"
          @current-change="getNoteDetailPageNum"
          :page-size="noteList.pageSize"
          :total="noteList.total"
        >
        </el-pagination>
      </el-dialog>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="800px">
        <div class="flex vip-card">
          <div class="grow">
            <h2 class="title">开通/续费会员</h2>
            <p style="margin: 36px 0">
              欲升级为付费用户，请在下方输入您的阅读卡编号和密码。
              获取阅读卡，可前往北京大学出版社官方<el-link type="primary"
                >淘宝店</el-link
              >
              或<el-link type="primary">微店</el-link>。
            </p>
            <div class="card-ipt">
              <el-input v-model="No" placeholder="请输入阅读卡编号"></el-input>
            </div>
            <div class="card-ipt">
              <el-input
                v-model="pwd"
                :show-password="true"
                type="password"
                placeholder="请输入阅读卡编号"
              ></el-input>
            </div>
            <div class="card-ipt">
              <el-button type="primary" style="width: 100%">确认</el-button>
            </div>
          </div>
          <div class="grow explain">
            <h5 class="margin24">账户权限说明</h5>
            <h6 class="margin24">未登录用户</h6>
            <p>仅能浏览网站首页、数字展示板块，无法阅读书籍。</p>

            <h6 class="margin24">注册用户</h6>
            <p>
              可以阅读每本书的前 50
              页。如果用户阅读时用关键词检索，且检索文本出现的位置超出前 50
              页，只显示页码数和约 200 字上下文。

              <br />无法使用文本分析、笔记批注功能。
            </p>
            <h6 class="margin24">付费用户</h6>
            <p>
              包括机构用户和个人用户，可全库阅读，并使用文本分析、笔记批注功能。欲升级账户，可在“帐户升级”弹窗内输入您购买的官方阅读卡信息。
              了解阅读卡详情，可前往北京大学出版社官方淘宝店或微店。
            </p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog> -->

      <!-- <payPage
        :centerDialogVisible="centerDialogVisible"
        :orderId="orderId"
        v-if="centerDialogVisible"
        @changeVisible="doChangeVisible"
      ></payPage>
      <memberRemind></memberRemind> -->
    </div>
  </div>
</template>
<script>
import eventBus from "@/utils/eventBus.js"
// import payPage from "../../components/payPage.vue"
// import memberRemind from "../../components/memberRemind.vue"
import {
  getNoteListNew,
  getNoteList,
  getFavordData,
  deleteFavor,
  deleteRead,
  deletBookNote,
  getReadList,
  getInfo,
  exportNotes,
  deleteNotesByBook,
  updateBaseInfo,
  orderList,
  cancelOrder
} from "@/api/api"
export default {
  name: "UCindex",
  // components: { payPage, memberRemind },
  data () {
    return {
      isInput: false,//输入框
      dialogVisibletwo: false,
      noteListParam: {},
      noteList: {
        pageNum: 1,
        pageSize: 12,
        data: [],
        total: 0,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      userInfo: {},
      activeName: "read",
      baseUrl: window.__baseUrl__,

      No: "",
      pwd: "",
      checkList: [],
      collectData: {
        pageNum: 1,
        pageSize: 12,
        rows: [],
        total: 0
      },
      noteData: {
        pageNum: 1,
        pageSize: 10,
        rows: [],
        total: 0
      },
      bookData: {
        pageNum: 1,
        pageSize: 12,
        rows: [],
        total: 0
      },

      tableData: {
        pageNum: 1,
        pageSize: 12,

        total: 0,
        rows: [
          {
            date: "2016-05-03",
            name: "王小虎",
            address: "上海市普陀区金沙江路 1518 弄"
          },
        ]
      },
      dialogVisible: false,
      xzlist: {},//查看item
      orderList: [],//订单列表\
      orderListTotal: 0,//订单数量
      orderListparam: {
        pageNum: 1,
        pageSize: 10,
        status: 1,
        isInvoice: 'N'
      },
      payStatus: ["待付款", "已付款", "已退款", "付款中", "退款中", "付款失敗", "退款失敗", "已關閉", "交易完成"],
      centerDialogVisible: false,
      orderId: 0,
      // daoqiDialogVisible: true,//到期
      ismature: false//是否到期
    }
  },
  mounted () {
    this.getUserInfo()
    this.getNoteData()
    this.getFavordData()
    this.getReadData()
    // this.userInfo = localStorage.userinfo ? JSON.parse(localStorage.userinfo) : {}
    // getInfo().then(d => {
    //   this.userInfo = d.user
    //   this.userInfo.avatar = (this.userInfo.avatar.indexOf('http') == -1) ? this.baseUrl + this.userInfo.avatar : this.userInfo.avatar

    // })
    // this.getOrderList()
    this.jugeMature()
  },
  methods: {
    getUserInfo () {
      getInfo().then(d => {
        this.userInfo = d.user
        if (this.userInfo.avatar && this.userInfo.avatar.indexOf('http') == -1) {
          this.userInfo.avatar = this.baseUrl + this.userInfo.avatar
        }
      })
    },
    jugeMature () {

      this.ismature = (this.userInfo && Date.parse(new Date(this.userInfo.vipValidityDate)) <= Date.now()) ? true : false
    },
    doChangeVisible (newData) {
      this.centerDialogVisible = newData
      this.getOrderList()
    },
    jugeMature () {

    },
    //取消订单
    cancelOrder (orderId) {
      cancelOrder(orderId).then((res) => {
        if (res.code == 200) {
          this.getOrderList()
          this.$message({
            message: res.msg,
            type: 'success'
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    zhifuOrder (orderId) {
      this.orderId = orderId
      this.centerDialogVisible = true

    },
    getOrderList () {
      orderList(this.orderListparam).then((res) => {
        console.log(res, 'res')
        this.orderList = res.rows
        this.orderListTotal = res.total
      })
    },
    orderListPageChange (page) {
      this.orderListparam.pageNum = page
      this.getOrderList()
    },
    paixuNode (colum) {
      if (colum.prop == "juanName") {
        this.noteList.orderByColumn = 'xmlId'
        this.noteList.isAsc = (colum.order == "ascending") ? 'asc' : 'desc'
        this.getnotedetail()
      }

    },
    handleAvatarSuccess (res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw)
      // this.userInfo.avatar
      // console.log(res, file, '/business/user/updateAvatar')
      if (res.code == 200) {
        this.userInfo.avatar = (res.imgUrl.indexOf('http') == -1) ? this.baseUrl + res.imgUrl : res.imgUrl
        eventBus.$emit("getUserInfo")
        this.$message.success("上傳成功")

      } else {
        this.$message.error("上傳失敗")
      }
    },
    beforeAvatarUpload (file) {
      // console.log(file, 'file')
      let geshi = ["image/jpg", "image/png", "image/jpeg"]
      // const isJPG = file.type === 'image/jpeg'
      // const isJPG = file.type == "image/jpg"
      // const isPng = file.type == "image/png"
      // const isJpeg = file.type == "image/jpeg"
      const isJPG = geshi.indexOf(file.type) != -1
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上傳頭像圖片只能是 jpg/png/jpeg 格式!')
        return false
      }

      if (!isLt2M) {
        this.$message.error('上傳頭像圖片大小不能超過 2MB!')
        return false
      }
      return isJPG && isLt2M
    },

    editUserInfo () {
      let param = { 'nickName': this.userInfo.nickName, 'organization': this.userInfo.organization, 'mail': this.userInfo.mail, 'qualification': this.userInfo.qualification, 'major': this.userInfo.major }
      updateBaseInfo(param).then((res) => {
        if (res.code == 200) {
          this.$message.success("編輯成功")
          eventBus.$emit("getUserInfo")
          this.isInput = false
        } else {
          this.$message.error(res.msg)
        }
      })

    },
    handleDelete (id) {
      // console.log(scope)
      deletBookNote({ noteId: id }).then(() => {

        this.getnotedetail()
        this.$message.success("刪除成功")
      })
    },
    // 筆記詳情
    getNoteDetailPageNum (e) {

      this.noteList.pageNum = e
      this.getnotedetail()
    },
    // 筆記詳情
    getnotedetail (item = {}) {
      // console.log(item, 'idd')
      if (item) this.xzlist = item
      this.dialogVisibletwo = true
      // console.log(item)
      if (item.bookId
      ) {
        this.noteList.bookId = item.bookId
      }

      this.noteListParam = { bookId: this.noteList.bookId, pageNum: this.noteList.pageNum, pageSize: this.noteList.pageSize, orderByColumn: this.noteList.orderByColumn, isAsc: this.noteList.isAsc }
      getNoteListNew(this.noteListParam)
        .then(d => {
          // console.log(d, 'ddd')
          this.noteList.data = d.rows.map((obj) => {

            let { juanName, noteTarget, noteContent, createTime, juanNum, noteId } = obj
            return { juanName, noteTarget, noteContent, createTime, juanNum, noteId }
          })
          this.noteList.total = d.total

        })
    },
    // 退出登录
    getout () {
      localStorage.removeItem("token")
      localStorage.removeItem("isVip")
      this.$router.replace({
        path: "/"
      })
      eventBus.$emit("outLogin", 1)
    },
    checkListChange (bookId) {
      const index = this.checkList.findIndex(d => d == bookId)
      if (index > -1) {
        this.checkList.splice(index, 1)
      } else {
        this.checkList.push(bookId)
      }
      this.$forceUpdate()
    },
    getBookReadParam (item) {
      // console.log(item, 'item')
      const {
        bookId,
        // juanNum,
        // juanName,
        catalogId,
        readPage,
        beginPage,
        // endPage
      } = item
      return this.formParam({
        id: bookId,
        catId: catalogId == 'undefined' ? '' : catalogId,
        page: readPage || beginPage
        // juanNum,
        // bookName: item.busBook.bookName,
        // catalogName: juanName,
        // bookPage: readPage,
        // beginPage,
        // endPage,
        // formSearchNotJump: 1,
        // formSearch: 1
      })
    },
    getCollect () {
      let { pageNum, pageSize } = this.collectData
    },
    getPageNum (e) {
      this.collectData.pageNum = e
      this.getFavordData()
    },
    getFavordData () {
      getFavordData({
        pageNum: this.collectData.pageNum,
        pageSize: this.collectData.pageSize
      }).then(d => {
        this.collectData.rows = d.rows
        this.collectData.total = d.total
      })
    },
    deleteFavor (id) {
      deleteFavor(id).then(() => {
        this.$message.success("删除成功")
        this.getFavordData()
        this.getNoteData()
      })
    },
    deleteRead (id) {
      // console.log(id, 'id')
      deleteRead(id).then(() => {
        this.$message.success("删除成功")
        this.getReadData()
      })
    },
    getNoteData () {
      let { pageNum, pageSize } = this.noteData
      getNoteList({ pageNum, pageSize }).then(d => {
        this.noteData.rows = d.rows
        this.noteData.total = d.total
      })
    },
    deletBookNote (item) {
      deletBookNote(item).then(() => {
        this.$message.success("删除成功")
        this.getNoteData()
      })
    },
    getReadData () {
      getReadList({
        pageSize: this.bookData.pageSize,
        pageNum: this.bookData.pageNum
      }).then(d => {
        this.bookData.rows = d.rows
        this.bookData.total = d.total
      })
    },
    getNookNum (item) {
      this.bookData.pageNum = item
      this.getReadData()
    },
    getNotePageNum (e) {
      this.noteData.pageNum = e
      this.getReadList()
    },

    // 订单表格
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    downNote () {
      exportNotes().then(d => {
        this.downBlobFile(d, "我的笔记")
      })
    },
    deleteNotes (id) {
      if (!id && !this.checkList.length) {
        return this.$message.warning("请先选择删除项")
      }
      id = id || this.checkList.join()

      deleteNotesByBook(id).then(() => {
        this.$message.success("删除成功")
        this.getNoteData()
        this.checkList = []
      })
    }
  },
  computed: {
    gettoken () {
      return localStorage.getItem('token')
    }
  },
  watch: {
    dialogVisibletwo (newVal) {
      // console.log(newVal, 'newVal')
      if (!newVal) {
        this.getNoteData()
      }
    }
  }

};
</script>
<style lang="less" scoped>
@import url(../../assets/iconfont.css);
@import url(../../pages/newcommon.css);
// /deep/ .readimg{
//   width: 156px;
//   height: 190px;
// }
// /deep/ .read .index .content .box-card .img{
//   width: 156px;
//   height: 190px;
// }
.redicon {
  color: #e60012;
}
p,
div {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.ver {
  writing-mode: vertical-rl;
}
.textright {
  text-align: right;
}
.marginTop {
  margin-top: 56px;
}
.kaitem {
  width: 225px;
  height: 140px;
  background: #ffffff;
  box-shadow: 0px 3px 8px 2px rgba(125, 125, 125, 0.3);
  border-radius: 10px;
  color: #344672;
  display: flex;
  justify-content: space-between;
  // font-family: "FangZheng-FanTi-Kaiti";
  overflow: hidden;
  .katitle {
    padding: 20px 0;
    font-size: 78px;
    line-height: 100px;
    font-weight: bold;
    margin-left: -16px;
    color: #1c3d85;
  }
  .kayue {
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
  .kastart {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .kaend {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .kacontent {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 0px;
  }
  .kades {
    font-size: 20px;
    font-weight: bold;
    color: #cc9933;
  }
}
/deep/.el-tooltip {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: start;
}
// .imgbccolor {
//   filter: brightness(1.5) contrast(130%) saturate(103%);
// }
.qxbutton {
  width: 70px;
  height: 29px;
  line-height: 29px;
  background: #3366cc;
  border-radius: 15px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.zfbutton {
  margin-bottom: 10px;
}
/deep/.el-form-item {
  margin-bottom: 12px;
}
/deep/.avatar-uploader {
  display: flex;
  justify-content: center;
  margin: 0px auto 8px;
}
.avatarborder {
  border: 1px dashed #d9d9d9;
  border-radius: 50px;
}
/deep/.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  // border-radius: 50px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.pointe {
  cursor: pointer;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-radius: 50px;
}
/deep/.avatar {
  width: 100px;
  height: 100px;
  display: block;
  border-radius: 50px;
}

/deep/.el-form-item__label {
  // margin: 6px 0;
  font-size: 18px;
  font-weight: bold;
  color: #a0a0a0;
  text-align: left;
  // line-height: 20px;
}
// /deep/.el-form-item {
//   margin-bottom: 8px;
// }
.fontstyle {
  margin: 8px 0;
  font-size: 18px;
  font-weight: bold;
  color: #a0a0a0;
}
.dialogimg {
  width: 18px;
  height: auto;
}
/deep/.el-dialog {
  margin-top: 3vh !important;
}
// /deep/.el-table .el-table__cell {
//   text-align: center;
// }
.between span {
  line-height: 36px;
  white-space: normal;
  word-wrap: break-word;
}
.index {
  width: 100%;
  height: 87.3vh;
  // background: #f0f8ff;
  background: #f5f5f5;

  .content-box {
    margin: 20px auto;
    width: 1200px;
    background: #fff;
    display: flex;
    // font-family: SimSun, PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica,
    //   Tahoma, Arial, PingFang SC-Light, Microsoft YaHei;
  }
  .user-info {
    // flex: 1;
    padding: 24px;
    // border-right: 1px solid #ccc;
    width: 400px;
    border-right: 2px solid #e4e7ed;

    .head-icon {
      width: 100px;
      height: 100px;
      display: block;
      margin: 40px auto 8px;
    }
    .user-name {
      font-size: 18px;
      font-weight: bold;
      color: #a0a0a0;
      text-align: center;
      margin-bottom: 10px;
    }

    .read-list {
      width: 82px;
      margin: 0 10px;
      // height: 71px;
      background: #ecf5ff;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px 0;

      img,
      i {
        width: 24px;
        height: 24px;
        font-size: 28px;
        margin-bottom: 12px;
      }
      font-size: 17px;

      font-weight: bold;
      color: #3366cc;
    }

    .user {
      .user-box {
        // width: 200px;
        width: 80%;
        /deep/.el-input__inner {
          // margin: 6px 0;
          font-size: 18px;
          font-weight: bold;
          color: #a0a0a0;
          font-family: "SimSun", "PingFangSC-Regular", "Roboto",
            "Helvetica Neue", Helvetica, Tahoma, Arial, "PingFang SC-Light",
            "Microsoft YaHei";
        }

        .box-title {
          font-size: 18px;

          font-weight: bold;
          color: #434343;
          margin: 32px auto;
          img {
            width: 24px;
            margin: 0 8px;
          }
        }
        > div {
          margin: 8px 0;
          font-size: 20px;

          font-weight: bold;
          color: #a0a0a0;
          > label {
            min-width: 70px;
          }

          &.tag-block {
            margin: 16px 0;
            height: 41px;
            background: #ecf5ff;
            border-radius: 10px;
            font-size: 18px;

            font-weight: bold;
            color: #3366cc;
            cursor: pointer;
            &.first-btn {
              margin-top: 54px;
            }
          }
        }
      }
    }
  }

  .content {
    flex: 1;
    flex-grow: 1;
    padding: 24px;

    .box-card {
      display: inline-block;
      margin-right: 8%;
      margin-bottom: 24px;
      // display: flex;
      width: 16%;
      height: 168px;
      // width: 7rem;
      // height: 10rem;
      position: relative;
      .layer {
        position: absolute;
        left: 0;
        top: 0;

        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.5);
        display: none;
      }
      &:hover {
        .layer {
          display: flex;
        }
      }
      &:nth-child(4n) {
        margin-right: 0;
      }

      .img {
        width: 100%;
        height: 100%;
      }
      .opera {
        > i {
          cursor: pointer;
        }
      }

      .process,
      .info {
        position: absolute;
        right: 0;
        top: 0;
        padding: 4px 8px;
        background: rgba(0, 0, 0, 0.5);
        font-size: 14px;
        color: #fff;
        box-sizing: border-box;
      }
      .info {
        top: initial;
        bottom: 0;
        width: 100%;
      }
    }

    .list-card {
      padding: 24px;
      margin-bottom: 16px;

      .batch-btn {
        > a {
          font-size: 14px;
          padding: 8px;
          font-weight: bold;
          color: #3366cc;
          border-radius: 12px;
          img {
            width: 16px;
            margin-right: 4px;
          }
        }
      }

      .book-info {
        flex: 1;
        flex-grow: 1;
        > img {
          width: 74px;
          height: 105px;
          margin-right: 32px;
          margin-left: 24px;
        }
        .title {
          font-size: 20px;
          font-weight: bold;
          color: #3366cc;
        }
        .desc {
          font-size: 14px;

          font-weight: bold;
          color: #a0a0a0;
        }
      }
    }

    .btn {
      // height: 1.23rem;

      border-radius: 1rem;
      padding: 0.4rem 0.8rem;
      font-size: 0.73rem;

      font-weight: bold;
      background: #ffffff;
      color: #3366cc;
      border: none;
      margin: 0.5rem 0;

      &.active {
        background: #3366cc;
        color: #ffffff;
      }

      img {
        width: 0.73rem;
        height: auto;
        margin-right: 0.3rem;
      }
      i {
        margin-right: 0.3rem;
      }
    }
  }
}

.sm-title {
  font-size: 14px;

  font-weight: bold;
  color: #3366cc;

  &.justify-center {
    width: 100px;
    .align-center {
      margin-bottom: 28px;
      text-decoration: none;
      color: #3366cc;

      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
    }
    img {
      width: 18px;
      height: auto;
    }
  }
}
.margin24 {
  margin: 12px 0;
}
.vip-card {
  .title {
    text-align: center;
  }
  .card-ipt {
    margin: 24px 0;
  }
  .explain {
    padding: 24px;
  }
}
/deep/ .el-tabs--left .el-tabs__header.is-left {
  float: none;
}
/deep/ .el-card__body {
  height: 100%;
  padding: 0;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/uc/index.vue